import * as z from 'zod/mini'
import { CreatePlaceBody, createPlaceBody, ManagedPlace, placeFields } from '@seiri/shared/common'
import { assertFormNumber, requiredFormNumber } from './form-schema'

/**
 * What the add and edit place dialogs edit. It differs from `CreatePlaceBody` only in `capacity`,
 * which an empty number input leaves `null` - hence its own schema and `toPlaceBody`.
 */
export const placeFormModel = z.object({
  name: placeFields.name,
  capacity: requiredFormNumber(placeFields.capacity.check(z.positive())),
  activityIds: createPlaceBody.shape.activityIds,
})
export type PlaceFormModel = z.infer<typeof placeFormModel>

export const emptyPlaceFormModel = (): PlaceFormModel => ({ name: '', capacity: null, activityIds: [] })

export const toPlaceFormModel = (place: ManagedPlace): PlaceFormModel => ({
  name: place.name,
  capacity: place.capacity,
  activityIds: place.compatibleActivities.map((activity) => activity.id),
})

export const toPlaceBody = ({ name, capacity, activityIds }: PlaceFormModel): CreatePlaceBody => ({
  name,
  capacity: assertFormNumber(capacity, 'capacity'),
  activityIds,
})
